/**
 * `settings-mail-beside-messaging` 'test': the Billing/Mail grid at the top of
 * Settings is taken apart — Mail & Calendar becomes a cell in the integrations
 * catalog beside Messaging, and Billing drops below the assistant-waiting card.
 *
 * Only the exact 'test' string treats, so a missing, boolean, or unknown
 * assignment is control and deactivating the flag is an instant rollback.
 */
export function settingsMovesMailBesideMessaging(variant: unknown): boolean {
  return variant === 'test'
}
